// extracted by mini-css-extract-plugin
module.exports = {"header":"header-view_header__3Sxpz","scrolled":"header-view_scrolled__1v4dU","navigation":"header-view_navigation__37DzJ"};